<template>
    <div>
        <b-form-group label="Question" label-for="question">
            <TipTap
                v-model="editable_content.question"
                :class="{'is-invalid': validating && !editable_content.question}"
                :menu_items="['bold', 'italic', 'underline', 'bullet_list', 'ordered_list', 'image', 'edit_html']"
            />
            <b-form-invalid-feedback :state="validating && !editable_content.question ? false : null">
                Question is required
            </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Regions" label-for="regions">
            <div class="d-flex">
                <div v-for="region, index in editable_content.regions" class="flex-fill p-2 border" :key="index">
                    <b-input-group>
                        <b-form-input 
                            :value="region.title" 
                            placeholder="Title" 
                            size="sm"
                            :state="validating && !region.title ? false : null"
                            @change="updateRegion(region, $event)
                        "></b-form-input>
                        <b-input-group-append>
                            <b-btn size="sm" variant="danger" @click="removeRegion(index, region)" v-if="index > 1">
                                <font-awesome-icon :icon="['fad', 'trash']" />
                            </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    <b-form-invalid-feedback :state="validating && !region.title ? false : null">
                        Region title is required
                    </b-form-invalid-feedback>
                </div>
            </div>
        </b-form-group>
        <b-btn size="sm" variant="outline-primary" @click="addRegion">
            <font-awesome-icon :icon="['fad', 'plus-square']" /> Add region
        </b-btn>

        <b-form-group label="Items to group" label-for="items" class="mt-4">
            <div v-for="item, index in editable_content.items" class="d-flex align-items-center mb-2" :key="item.id">
                <div class="flex-grow-1">    
                    <b-input-group>
                        <TipTap
                            v-model="item.value"
                            :class="{'is-invalid': validating && !item.value, 'form-control': true}"
                            :menu_type="'wysiwyg_menu_type'"
                            :hide_word_count="true"
                            :show_related_media_modal="item.show_add_related_media_modal"
                            @closeSbpModal="item.show_add_related_media_modal = false"
                        />
                        <b-input-group-append>
                            <b-btn variant="info" content="Add SBP Image" v-tippy="{placement: 'top'}" @click="item.show_add_related_media_modal = true">
                                SBP
                            </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    <b-form-invalid-feedback :state="validating && !item.value ? false : null">
                        Item is required
                    </b-form-invalid-feedback>
                </div>
                <div class="ml-2">
                    <b-form-select v-model="item.region" :state="validating && !item.region ? false : null">
                        <b-form-select-option :value="null">Select region</b-form-select-option>
                        <b-form-select-option v-for="region in editable_content.regions" :value="region.title">{{region.title}}</b-form-select-option>
                    </b-form-select>
                    <b-form-invalid-feedback :state="validating && !item.region ? false : null">
                        Region is required
                    </b-form-invalid-feedback>
                </div>
                <div class="ml-2">
                    <b-btn variant="link" class="text-danger" @click.prevent="removeItem(index)">
                        <font-awesome-icon :icon="['far', 'times']" />
                    </b-btn>
                </div>
            </div>
        </b-form-group>
        <div class="mb-3">
            <b-btn size="sm" variant="outline-primary" @click="addItem">
                <font-awesome-icon :icon="['fad', 'plus-square']" /> Add item
            </b-btn>
        </div>
    </div>
</template>

<style scoped>
.form-control {
    height: auto;
}
.form-control >>> .editor-content {
    border: none;
}
.form-control >>> .ProseMirror {
    padding: 0;
    min-height: 60px;
}
</style>

<script>
import { mapState } from 'vuex'

export default {
    data: () => ({
        editable_content: {
            'question': '',
            items: [
                {id: Math.floor(Math.random() * 1000000), value: '', show_add_related_media_modal: false, region: null},
                {id: Math.floor(Math.random() * 1000000), value: '', show_add_related_media_modal: false, region: null}
            ],
            regions: [
                {'title': 'a'}, {'title': 'b'}
            ]
        }
    }),
    props: [
        'question'
    ],
    components: {
        TipTap: () => import('@/components/tiptap/TipTap')
    },
    computed: {
        ...mapState({
            validating: state => state.utilities.validating
        })
    },
    watch: {
        editable_content: {
            handler (editable_content) {
                if (editable_content) {
                    this.$set(this.question, 'content', editable_content)
                }
            },
            deep: true
        }
    },
    methods: {
        addRegion() {
            this.editable_content.regions.push({'title': ''})
        },
        removeRegion(index, region) {
            this.editable_content.regions.splice(index, 1)
            _.each(this.editable_content.items, item => {
                if(item.region == region.title) {
                    item.region = null
                }
            })
        },
        updateRegion(region, event) {
            _.each(this.editable_content.items, item => {
                if(item.region == region.title) {
                    item.region = event
                }
            })
            region.title = event
        },
        addItem() {
            this.editable_content.items.push({id: Math.floor(Math.random() * 1000000), value: '', show_add_related_media_modal: false, region: null})
        },
        removeItem(index) {
            this.editable_content.items.splice(index, 1)
        }
    },
    created() {
        if (this.question && this.question.content) {
            let q = _.cloneDeep(this.question)
            this.$set(this.editable_content, 'items', q.content.items)
            this.$set(this.editable_content, 'regions', q.content.regions)
            this.$set(this.editable_content, 'question', q.content.question)
            _.each(this.editable_content.items, item => {
                this.$set(item, 'id', Math.floor(Math.random() * 1000000))
                this.$set(item, 'show_add_related_media_modal', false)
            })
        }
    }
}
</script>
